import { useNavigate, useLocation } from "react-router-dom";
import { getEnquiry } from "../../../../Service/RM";
import { useState, useMemo, useEffect } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { VscEye } from "react-icons/vsc";
import { IoIosAddCircleOutline } from "react-icons/io";
import Loader from "../../../../reusableUI/loader";
import { formatPhoneNumber } from "../../../../utils/Functions";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import { CommonImages } from "../../../../reusableUI/images";
import ReusableTable from "../../../../reusableUI/table";
import Page from "../../../../reusableUI/page";

const EnquiryList = ({ searchTerm }) => {
  const [loading, setLoading] = useState(true);
  const [paginationPage, setPaginationPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("all");
  const [userList, setUserList] = useState([]);
  const [noUsersFound, setNoUsersFound] = useState(false);
  const [selectedPageCount, setSelectedPageCount] = useState(() => {
    const savedPageCount = localStorage.getItem("pageCount");
    return savedPageCount ? parseInt(savedPageCount, 10) : 50;
  });

  const [sortBy, setSortBy] = useState(() => {
    const savedSortBy = localStorage.getItem("sortBy");
    return savedSortBy ? JSON.parse(savedSortBy) : [];
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getUserList();
    const savedValue = localStorage.getItem("selectedValue");
    if (savedValue) {
      setSelectedValue(savedValue);
    }
  }, []);

  useEffect(() => {
    if (location.state?.currentPage !== undefined) {
      setPaginationPage(location.state.currentPage);
    }
  }, [location.state]);

  const getUserList = async () => {
    try {
      const result = await getEnquiry();
      if (!result.error && Array.isArray(result.data)) {
        setUserList(result.data);
        setLoading(false);
      } else {
        console.error("Failed to fetch hospital list");
      }
    } catch (error) {
      console.error("Error fetching hospital list:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value);
    localStorage.setItem("selectedValue", event.target.value);
  };

  const AddHospital = () => {
    localStorage.setItem("profilePage", "hospital");
    navigate("/addhospital");
  };
  console.log(userList);
  const getColumns = () => [
    {
      Header: "S.No",
      accessor: "serial",
      id: "sno",
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      disableSortBy: false,
      sortType: (rowA, rowB) => rowA.index - rowB.index,
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { index } }) => (
        <div className="text-blue-600 text-[12px]">{index + 1})</div>
      ),
    },
    {
      Header: "Provider Type",
      accessor: "org",
      id: "providerType",
      width: 130,
      minWidth: 120,
      maxWidth: 150,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <div className="text-blue-600 text-[12px]">
          {original?.partnerType || "-"}
        </div>
      ),
    },
    {
      Header: "Name",
      accessor: "providerName",
      id: "name",
      width: 200,
      minWidth: 180,
      maxWidth: 250,
      disableSortBy: false,
      sortType: (rowA, rowB) => {
        const nameA = (rowA.original?.basicInfo?.name || "").toLowerCase();
        const nameB = (rowB.original?.basicInfo?.name || "").toLowerCase();
        return nameA.localeCompare(nameB);
      },
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => (
        <div className="text-blue-600 text-[12px]">
          {original?.basicInfo?.name || "-"}
        </div>
      ),
    },
    {
      Header: "Contact Person",
      accessor: "contactPerson",
      id: "contactPerson",
      width: 180,
      minWidth: 160,
      maxWidth: 220,
      disableSortBy: false,
      sortType: (rowA, rowB) => {
        const nameA = (
          rowA.original?.contactPersonInfo?.[0]?.nameInfo?.fullName || ""
        ).toLowerCase();
        const nameB = (
          rowB.original?.contactPersonInfo?.[0]?.nameInfo?.fullName || ""
        ).toLowerCase();
        return nameA.localeCompare(nameB);
      },
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => {
        const title = original?.contactPersonInfo?.[0]?.nameInfo?.title;
        const fullName = original?.contactPersonInfo?.[0]?.nameInfo?.fullName;

        return (
          <div className="text-[12px]">
            {title && fullName ? `${title}. ${fullName}` : "-"}
          </div>
        );
      },
    },
    {
      Header: "Phone",
      accessor: "contactNumber",
      id: "phone",
      width: 140,
      minWidth: 130,
      maxWidth: 160,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "center",
        padding: "8px",
      },
      style: {
        textAlign: "center",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => {
        const phone = original?.contactPersonInfo?.[0]?.phone;

        return (
          <div className="text-blue-600 text-[12px] whitespace-nowrap">
            {phone ? formatPhoneNumber(phone) : "-"}
          </div>
        );
      },
    },
    {
      Header: "Contact Time",
      accessor: "time",
      id: "contactTime",
      width: 180,
      minWidth: 160,
      maxWidth: 220,
      disableSortBy: false,
      sortType: "alphanumeric",
      headerStyle: {
        textAlign: "left",
        padding: "8px",
      },
      style: {
        textAlign: "left",
        padding: "8px",
      },
      Cell: ({ row: { original } }) => {
        const days = original?.preferredConnection?.days;
        const time = original?.preferredConnection?.time;

        return (
          <div className="text-[12px]">
            {days && time ? `${days.join(", ")} - ${time}` : "-"}
          </div>
        );
      },
    },
  ];

  const filteredData = useMemo(() => {
    let filtered = Array.isArray(userList) ? [...userList] : [];

    const value = selectedValue?.toLowerCase();

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter((item) => {
        const name = item?.basicInfo?.name?.toLowerCase() || "";
        const phone = String(item?.contactPersonInfo?.[0]?.phone ?? "");
        const city = item?.addressInfo?.city?.toLowerCase() || "";

        return (
          name.includes(term) || phone.includes(term) || city.includes(term)
        );
      });
    }

    const noResults = filtered.length === 0;
    setNoUsersFound(noResults);

    return noResults ? [] : filtered.reverse();
  }, [selectedValue, userList, searchTerm]);

  console.log(filteredData);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page: tablePage,
    prepareRow,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex, sortBy: currentSortBy },
  } = useTable(
    {
      columns: useMemo(() => getColumns(), [selectedValue]),
      data: filteredData,
      initialState: {
        pageSize: selectedPageCount,
        pageIndex: paginationPage,
        sortBy,
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    localStorage.setItem("sortBy", JSON.stringify(currentSortBy));
  }, [currentSortBy]);

  useEffect(() => {
    if (pageIndex !== paginationPage) {
      setPaginationPage(pageIndex);
    }
  }, [pageIndex]);

  if (loading) return <Loader />;

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="bg-[#F3F6F5]">
          <div className="overflow-x-auto bg-white rounded-2xl w-auto md:w-auto lg:w-auto shadow-lg p-2 h-[85vh] m-2 flex flex-col gap-3 ">
            <div className="flex justify-between items-center mt-[-25px]">
              <div className="flex flex-row items-center mt-4">
                <p className="text-[14px] font-bold ml-2 mt-4 mb-2">
                  Enquiry List ({filteredData.length})
                </p>
              </div>
            </div>
            <div className="overflow-x-auto max-h-[70vh] mt-[-10px] ">
              <div className="min-w-full w-[100%]">
                <ReusableTable
                  columns={getColumns()}
                  getTableProps={getTableProps}
                  getTableBodyProps={getTableBodyProps}
                  headerGroups={headerGroups}
                  tablePage={tablePage}
                  prepareRow={prepareRow}
                  filterIcon={CommonImages.filter}
                  searchTerm={searchTerm}
                />
              </div>
            </div>
            <div className="mb-2">
              <Page
                paginationPage={paginationPage}
                nextPage={nextPage}
                previousPage={previousPage}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                screen="hospital"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EnquiryList;
